var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 19.5C20.5 20.163 20.2366 20.7989 19.7678 21.2678C19.2989 21.7366 18.663 22 18 22C17.337 22 16.7011 21.7366 16.2322 21.2678C15.7634 20.7989 15.5 20.163 15.5 19.5C15.5 18.837 15.7634 18.2011 16.2322 17.7322C16.7011 17.2634 17.337 17 18 17C18.663 17 19.2989 17.2634 19.7678 17.7322C20.2366 18.2011 20.5 18.837 20.5 19.5ZM10.5 19.5C10.5 20.163 10.2366 20.7989 9.76777 21.2678C9.29893 21.7366 8.66304 22 8 22C7.33696 22 6.70107 21.7366 6.23223 21.2678C5.76339 20.7989 5.5 20.163 5.5 19.5C5.5 18.837 5.76339 18.2011 6.23223 17.7322C6.70107 17.2634 7.33696 17 8 17C8.66304 17 9.29893 17.2634 9.76777 17.7322C10.2366 18.2011 10.5 18.837 10.5 19.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 19.5H10.5M20.5 19.5H21.263C21.483 19.5 21.593 19.5 21.685 19.488C22.016 19.4468 22.3239 19.2964 22.5599 19.0606C22.7959 18.8248 22.9465 18.517 22.988 18.186C23 18.093 23 17.983 23 17.763V15C23 13.2761 22.3152 11.6228 21.0962 10.4038C19.8772 9.18482 18.2239 8.5 16.5 8.5M3 6H13C14.414 6 15.121 6 15.56 6.44C16 6.878 16 7.585 16 9V17.5M3 14.75V17C3 17.935 3 18.402 3.201 18.75C3.33265 18.978 3.52199 19.1674 3.75 19.299C4.098 19.5 4.565 19.5 5.5 19.5M3 9H9M3 12H7",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.fb10983f193809eb301f56e0ff772917.svg";
export { ForwardRef as ReactComponent };